<!-- <div class="preloader" [hidden]="load">
    <div class="loading">
        <img src="assets/images/loader/loader.svg" alt="">
    </div>
</div> -->
<app-loading [hidden]="load"></app-loading>
<section class="page-title page-title-layout3 text-center bg-overlay bg-parallax " style="background-size: cover; background-position: center center;">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <h1 class="pagetitle__heading mb-10">Research Projects</h1>
            </div>
        </div>
    </div>
</section>

<section class="portfolio-layout3">
    <div class="container">
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-3">
                <ul class="portfolio-filter  justify-content-center list-unstyled" style="padding: 11px;">
                    <li [ngClass]="{'active2': selectedItem == null}" routerLink="/researchProjects"><a>All Projects</a></li>
                    <li *ngFor="let item of arrayResearchProjectCategory" [ngClass]="{'active2': selectedItem == item.postID}">
                        <a style="cursor: pointer;" routerLink="/researchProjects/{{item.postID}}">{{item.postTitle}}</a>
                    </li>
                </ul>
            </div>

            <div class="row col-sm-12 col-md-12 col-lg-9" style="min-height: 400px;">

                <div class="col-sm-12 col-md-12 col-lg-12" *ngFor="let item of arrayProjects">
                    <div class="job-item">
                        <div class="row">
                            <div class="col-sm-12 col-md-12 col-lg-12">
                              <a routerLink='/researchProjectDetails/{{item.postID}}'>
                                <h4 class="job-item__title job-item__type">{{item.postTitle}}</h4>
                                  <img src="https://api2.wcrg.org:444/images/post/{{item.postImage}}">
                              </a>
                              <span class="spanAlign">{{item.postSubTitle}}</span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</section>
